import React from 'react';
import { Box, Typography } from '@mui/material';
import { chatTheme } from '../../theme/chatTheme';

const FunctionCallIndicator = ({ functionName }) => {
  return (
    <Box sx={chatTheme.functionCallIndicator.container}>
      <Box
        sx={{
          width: '16px',
          height: '16px',
          borderRadius: '50%',
          backgroundColor: '#ef4192',
          ...chatTheme.functionCallIndicator.icon,
        }}
      />
      <Typography variant="caption" sx={{ fontWeight: 500 }}>
        {functionName 
          ? `Lumi is executing: ${functionName}...`
          : 'Lumi is processing your request...'}
      </Typography>
    </Box>
  );
};

export default FunctionCallIndicator;

